import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { AppState } from '../ngrx/template/template.reducers';
import { StatePersistenceUtil } from './state-persistence.util';

/** Normalize a router URL or pathname to a template slug key. */
export function extractTemplateSlug(url: string): string {
  return url.split('?')[0].split('#')[0].replace(/^\//, '');
}

/** True when the slug's template is ready from NgRX store or localStorage cache. */
export function isTemplateSlugReady(
  store: Store<AppState>,
  slug: string
): boolean {
  if (!slug) {
    return false;
  }

  let loadedInStore = false;
  store
    .select((state) => state.template.slugs[slug]?.loaded === true)
    .pipe(take(1))
    .subscribe((loaded) => {
      loadedInStore = loaded;
    });

  return loadedInStore || StatePersistenceUtil.isSlugCached(slug);
}
